import * as React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

type Props = {
  image: any
  title: string
  description: string | React.ReactElement
}
export const WorkAroundYouSection: React.FC<Props> = ({ description, title, image }) => (
  <GraySection>
    <Container>
      <div className="grid md:grid-cols-2 gap-4" style={{ borderBottom: '1px solid #818b92', paddingBottom: '40px' }}>
        <div>
          <h2 className={'title'}>{title}</h2>
          <p className={'description'}>{description}</p>
        </div>
        <div className={'flex flex-col justify-center'}>
          <Image
            src={image}
            alt="NuBrakes Mobile Repair Works Around Your Schedule"
            layout="responsive"
            width={800}
            height={440}
          />
        </div>
      </div>
    </Container>
  </GraySection>
)
